// Module
var code = " <sb-app-activity-tracker style=\"height:100%\" id=\"trackerGrid\"></sb-app-activity-tracker> <sb-legend class=\"sb-tracker__legend\" entries=\"tracker.legendEntries\" ng-show=\"tracker.isLegendVisible\"></sb-legend> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/tracker/tracker.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;